/* eslint-disable object-shorthand */
import * as marietta from '../../..';
import { Dialog } from '../../../core/view';

/**
 * MyHomeCloud会員登録ダイアログ
 */
class SignupDialog extends Dialog {
    callBack:Function;

    signUpClicked:boolean = false;

    /**
         * コンストラクタ
         */
    constructor(draggable) {
      super(draggable);

      // ダイアログのコンテンツ生成
      const id = 'signupDialog';
      let title:string = '';
      // タイトル
      switch (marietta.webcad.WebCADGlobal.language) {
        case 'jp': title = 'アカウント登録'; break;
        default: title = 'Sign Up'; break;
      }

      let contents = '<div class="dialogSignupDialog">\n';
      contents += '<p class="linkChangeDialog"><a href="#"><span class="jp">既に登録されている方はこちら</span><span class="en">Sign in</span></a></p>\n';
      contents += '<div class="tableBox">\n';
      contents += '<p class="notationMessage"><span class="jp">データを保存するにはアカウント登録が必要です。<br>メールアドレスを入力して、アカウント登録を行ってください。</span><span class="en">Sign up and save your data.<br>Please input your e-mail.</span></p>\n';
      contents += '<table>\n';
      contents += '<tbody>\n';
      contents += '<tr>\n';
      contents += '<th><span class="jp">メールアドレス：</span><span class="en">e-mail:</span></th><td><input type="text" id="input_mailaddress" maxlength="100"> *</td>\n';
      contents += '</tr>\n';
      contents += '</tbody>\n';
      contents += '</table>\n';
      contents += '<p class="dialogInlineError" id="dialogSignupDialogError"></p>\n';
      contents += '</div>\n';
      contents += '</div>\n';
      let footer = '<button id="btnDoneLogin" value="1"><span class="jp">ＯＫ</span><span class="en">OK</span></button>';
      footer += '<button value="0"><span class="jp">キャンセル</span><span class="en">Cancel</span></button>';

      this.createDialog(id, title, contents, footer);
      (this.viewObj).querySelectorAll(('.dialogFooter')).forEach((param) => {
        param.querySelector('button').addEventListener('click', this.onFooterBtnClicked);
      });
      (this.viewObj).querySelectorAll(('.linkChangeDialog')).forEach((param) => {
        param.querySelector('a').addEventListener('click', this.onTextlinkClicked);
      });

      document.querySelector('#input_mailaddress').addEventListener('keydown', (e) => {
        e.stopImmediatePropagation();
      });
      // お掃除
      this.signUpClicked = false;
    }

    /**
         * linkChangeDialogがクリックされた
         */
        onTextlinkClicked = (e) => {
          e.preventDefault();
          const tarDialog = marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.LoginDialog) as marietta.webcad.view.dialog.LoginDialog;
          tarDialog.callBack = this.callBack;
        }

        /**
         * フッターのボタンがクリックされた
         */
        onFooterBtnClicked = (e) => {
          e.preventDefault();
          if (Number((e.currentTarget).value)) {
            // エラーメッセージの初期化
            document.getElementById('dialogSignupDialogError').innerHTML = '';

            const url = marietta.webcad.WebCADGlobal.webcad2Dmanager.base_url + marietta.webcad.net.default.param.default.ActionName.PREREGIST;
            let data = `email=${(<HTMLInputElement>document.getElementById('input_mailaddress')).value}`;
            // eslint-disable-next-line no-undef
            data += `&fuel_csrf_token=${fuel_csrf_token()}`;

            const self = this;
            if (!this.signUpClicked) {
              this.signUpClicked = true;
              marietta.webcad.WebCADGlobal.showBusy();
              const headers = {
                Accept: 'application/json',
              };
              fetch(url, {
                method: 'POST',
                body: data,
                headers,
              }).then((response) => {
                if (response.status >= 200 && response.status <= 299) {
                  return response.json();
                }
                throw Error(response.statusText);
              }).then((info) => {
                self.signUpClicked = false;
                marietta.webcad.WebCADGlobal.hideBusy();
                // ログイン済み
                if (info.error === undefined) {
                  // 本会員登録してくださいダイアログの表示
                  marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('INFO_REGISTER_COMPLETE'), '', self.onSignUpComplete);

                  self.close();
                } else {
                  // エラーメッセージの初期化
                  document.getElementById('dialogSignupDialogError').innerHTML = info.error.message;
                }
              }).catch(() => {
                self.signUpClicked = false;
                marietta.webcad.WebCADGlobal.hideBusy();
                // エラーメッセージの初期化
                switch (marietta.webcad.WebCADGlobal.language) {
                  case 'en': document.getElementById('dialogSignupDialogError').innerHTML = 'Error: Cannot find connection. Please check your network.'; break;
                  default: document.getElementById('dialogSignupDialogError').innerHTML = '通信エラー:ネットワーク環境をご確認ください。'; break;
                }
              });
            }
          } else {
            // webcadを閉じるフラグをおろす
            marietta.webcad.WebCADGlobal.webcad2Dmanager.closeWebcadAfterEvent = false;

            // ダイアログを閉じる
            marietta.webcad.WebCADGlobal.removeDialog();
          }
        }

        /**
         * 会員登録成功
         * （ログインIDの取得）
         */
        onSignUpComplete=() => {
          // ログインIDの取得
          const url = marietta.webcad.WebCADGlobal.webcad2Dmanager.base_url + marietta.webcad.net.default.param.default.ActionName.GET_USER_INFO;
          // eslint-disable-next-line no-undef
          const data = `fuel_csrf_token=${fuel_csrf_token()}`;
          const self = this;

          const headers = {
            Accept: 'application/json',
          };
          fetch(url, {
            method: 'GET',
            body: data,
            headers,
          }).then((response) => {
            if (response.status >= 200 && response.status <= 299) {
              return response.json();
            }
            throw Error(response.statusText);
          }).then((info) => {
            // ログインＩＤの保持
            marietta.webcad.WebCADGlobal.webcad2Dmanager.userID = info.data.id;
            // アクティベーションチェック後、次の処理を行う
            marietta.webcad.WebCADGlobal.activatableCheck(() => {
              self.activatableCheckSuccess();
            });
          }).catch(() => {
            // IDが取得できない場合は、アクティベーションチェックもせずに、そのまま続行
            if (self.callBack != null) {
              self.callBack();
            }
            self.close();
          });
        }

        /**
         * アクティベーションチェック完了
         */
        activatableCheckSuccess():void {
          if (this.callBack !== null) {
            this.callBack();
          }
          this.close();
        }
}
export default SignupDialog;
